import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import {
    SelectAllPatients,
    SelectAllRiders,
} from "../OfflineDb/IndexDbTranscSP";
import AlertModal from "../CommonControlls/AlertModal";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import DropDown from "../CommonControlls/DropdownRendrer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
    return store;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};

class PatientSample_List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Table

            data: [],
            ExportLoading: false,
            ExportLoadingPdf: false,
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,
            exportLoading: false,
            isfollowUpCase: false,
            filterByCompletionDate: false,

            sortField: "id",
            idsortOrder: "desc",
            assignmentIdsortOrder: "",
            provinceNamesortOrder: "",
            districtNamesortOrder: "",
            hcfNamesortOrder: "",
            hcfTypesortOrder: "",
            SampleStatus: "",

            permissions: [],

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },



            HCFLoader: false,
            HCFList: [],

            PatientSampleStatus: [
                { id: 1, name: "Fasting/Morning" },
                { id: 2, name: "Random" },
            ],

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: [],

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: [],

            XpertSitelist: [],
            Patientslist: [],
            Riderslist: [],

            AFBlist: [
                { id: 1, name: "Negative" },
                { id: 2, name: "Positive" },
            ],
            AFBId: 0,

            noOfSlides: 0,

            AFBTypelist: [
                { id: 1, name: "Scanty" },
                { id: 2, name: "1+" },
                { id: 3, name: "2+" },
                { id: 4, name: "3+" },
            ],
            AFBTypeId: 0,

            isNegativeResult: false,

            SampleId: 0,
            category: "",

            tbNumber: 3,

            startDate: new Date(),
            endDate: new Date(),

            MTBId: 0,
            MTBRatingId: null,

            MTBlist: [
                { id: 1, name: "Invalid" },
                { id: 2, name: "Detected" },
                { id: 3, name: "Not Detected" },
                {
                    id: 4,
                    name: "Error",
                },
            ],
            MTBRatingList: [
                { id: 1, name: "High" },
                { id: 2, name: "Medium" },
                { id: 3, name: "Low" },
                { id: 4, name: "Very Low" },
                { id: 5, name: "Trace" },
            ],

            RRlist: [
                { id: 1, name: "Invalid" },
                { id: 2, name: "Detected" },
                { id: 3, name: "Not Detected" },
                {
                    id: 4,
                    name: "Indeterminate",
                },
            ],
            RRId: 0,

            SrList: [],
            SrId: [],
            FilteredSrs: [],
            HCFTypelist: [
                { id: "1-a", name: "BHU" },
                { id: "1-b", name: "GP" },
                { id: "2-a", name: "RHC" },
                { id: "2-b", name: "PPM" },
            ],
            HCFTypeId: [],

            // Add MTB Result filter state
            MTBResultId: [],

            csvFileLink: null,
        };
    }

    HandleDateChange = (Field, date) => {
        this.setState(
            { [Field]: date === "" || date == null ? new Date() : date },
            () => {
                if (
                    Field === "startDate" &&
                    this.state.startDate > this.state.endDate
                ) {
                    this.setState({ endDate: this.state.startDate });
                }
            }
        );
    };
    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState(
            {
                [fieldId]: value,
                // isSaveSearch: this.state.isSearchChanged ? true : false
            },
            () => {
                if (fieldId === "ProvinceId") {
                    this.FilterDistricts(value);
                }
                if (fieldId === "SrId") {
                    const tempDistricts = this.state.Districtlist;
                    const tempSrs = this.state.SrId;
                    var selectedSrs = Common.ConvertToCommaSplitArray(tempSrs, "id");
                    var filteredSelectedDistricts = tempDistricts.filter(
                        (obj) => selectedSrs.indexOf(obj.subrecipientid) > -1
                    );
                    this.setState({
                        FilteredDistrictlist: filteredSelectedDistricts,
                    });
                }

                if (fieldId === "HCFTypeId") {
                    // For multi-select, we need to handle multiple values
                    // For now, we'll set category to empty string when multiple types are selected
                    // or determine based on the first selected value if only one is selected
                    if (value && value.length === 1) {
                        const category =
                            String(value[0].id).charAt(2) === "b" ? "private" : "public";
                        this.setState({ category });
                    } else {
                        this.setState({ category: "" });
                    }
                }

                // if(fieldId === 'DistrictId') {
                //     var selectedDistricts = this.state.DistrictId
                //     var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(selectedDistricts, "id")

                //     const TempSr = this.state.SrList
                //     const filtered = TempSr.filter((el) => {
                //         return filteredDistrictIdArr.indexOf(el.districtId) > -1
                //     })

                //     this.setState({
                //         FilteredSrs: filtered
                //     })
                // }
            }
        );
    };
    FilterDistricts = (value) => {
        // filter ditrict list
        var TempArr = this.state.Districtlist;
        var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
        var filteredDistrictList = TempArr.filter(function (obj) {
            return selectedProvince.indexOf(obj.provinceId) > -1;
        });

        const tempSrs = this.state.SrList;
        const filteredSrs = tempSrs.filter(
            (item) => selectedProvince.indexOf(item.provinceid) > -1
        );

        // filter district selected values
        var selectedDistricts = this.state.DistrictId;
        var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
            filteredDistrictList,
            "id"
        );
        var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
            return filteredDistrictIdArr.indexOf(obj.id) > -1;
        });

        this.setState({
            // FilteredDistrictlist: filteredDistrictList,
            // DistrictId: filteredSelectedDistricts,
            FilteredSrs: filteredSrs,
        });
    };

    handleIncludeDateCheckboxChange = (item) => {
        // Handle "Include Date" checkbox change
        console.log(`Checkbox ${item} changed`);
    };

    render() {
        const CellMenu = (cell, row) => {
            return (
                <div>
                    {this.state.permissions.includes("patientsamples-delete") && (
                        <button
                            onClick={() => this.onDelete(row.id, row.assignmentId)}
                            data-toggle="tooltip"
                            title="Delete"
                            class="btn TableRow_btn"
                        >
                            <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
                        </button>
                    )}
                    {this.props.UserAuthentication.UserInfo?.roleId === 6 ||
                        (row.afbResult != null && row.afbResult !== "") ? (
                        ""
                    ) : (
                        <button
                            onClick={() => {
                                this.ShowSampleStatusModal(row.id);
                            }}
                            data-toggle="tooltip"
                            title="Enter Result"
                            class="btn TableRow_btn"
                        >
                            <i class="fa fa-file-text-o text-primary" aria-hidden="true"></i>
                        </button>
                    )}
                </div>
            );
        };

        function avatarformatter(cell, row) {
            return (
                <span>
                    {row.patientName}
                    <br />
                    <span>{row.patientContact}</span>
                </span>
            );
        }

        const AFBResultFormatter = (cell, row) => {
            // if (
            //   this.props.UserAuthentication.UserInfo?.roleId === 1 ||  this.props.UserAuthentication.UserInfo?.roleId === 3 ||
            //   this.props.UserAuthentication.UserInfo?.roleId === 8 ||  this.props.UserAuthentication.UserInfo?.roleId === 14
            // )
            if (this.state.permissions.includes("patientsamples-update")) {
                return (
                    <span>
                        {cell === 1 ? (
                            "-Ve"
                        ) : cell === 2 ? (
                            "+Ve"
                        ) : cell === 3 ? (
                            "Invalid"
                        ) : (
                            <button
                                onClick={() => {
                                    this.ShowSampleStatusModal(row.id);
                                }}
                                data-toggle="tooltip"
                                disabled={
                                    row.hcfType == 1 &&
                                        (row.assignmentId === null ||
                                            row.assignmentId === "" ||
                                            row.assignmentId == 0)
                                        ? true
                                        : false
                                }
                                title={
                                    row.hcfType == 1 &&
                                        (row.assignmentId === null ||
                                            row.assignmentId === "" ||
                                            row.assignmentId == 0)
                                        ? "Sample is not part of any job to RHC"
                                        : "Enter AFB Result"
                                }
                                class="btn TableRow_btn"
                            >
                                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            </button>
                        )}
                    </span>
                );
            } else {
                return (
                    <span>{cell == 1 ? "Negative" : cell == 2 ? "Positive" : ""}</span>
                );
            }
        };

        const MTBResultFormatter = (cell, row) => {
            if (this.state.permissions.includes("patientsamples-update")) {
                //   this.props.UserAuthentication.UserInfo?.roleId == 1 || this.props.UserAuthentication.UserInfo?.roleId == 3 ||
                //   this.props.UserAuthentication.UserInfo?.roleId == 8 ||  this.props.UserAuthentication.UserInfo?.roleId === 14
                // ) {
                var isAFBEntered =
                    row.afbResult == 0 || row.afbResult == "" || row.afbResult == null
                        ? true
                        : true;
                return (
                    <span>
                        {cell == 1 ? (
                            "Invalid"
                        ) : cell == 2 ? (
                            "Detected"
                        ) : cell == 3 ? (
                            "Not Detected"
                        ) : cell == 4 ? (
                            "Error"
                        ) : (
                            <button
                                onClick={() => {
                                    this.ShowMTBSampleStatusModal(row.id);
                                }}
                                data-toggle="tooltip"
                                disabled={!isAFBEntered}
                                title={
                                    isAFBEntered == false
                                        ? "Please enter AFB result to enter MTB"
                                        : row.afbResult == 1 && row.isNegativeResultBypass == false
                                            ? "Please enable negative AFB result bypass of sample to enter MTB result"
                                            : row.assignmentId == null || row.assignmentId == ""
                                                ? "Sample is not part of any job to expertsite"
                                                : "Enter MTB Result"
                                }
                                class="btn TableRow_btn"
                            >
                                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            </button>
                        )}
                    </span>
                );
            } else {
                return (
                    <span>
                        {cell == 1
                            ? "Invalid"
                            : cell == 2
                                ? "Detected"
                                : cell == 3
                                    ? "Not Detected"
                                    : cell == 4
                                        ? "Error"
                                        : ""}
                    </span>
                );
            }
        };

        const SampleStatusFormatter = (id, status) => {
            return (
                <>
                    <button
                        onClick={() => {
                            this.ChangeSampleStatusModal(id, status);
                        }}
                        data-toggle="tooltip"
                        title="Update Sample Status"
                        className="btn TableRow_btn"
                    >
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                    </button>
                    <span>{status}</span>
                </>
            );
        };

        const MicroscopyFormatter = (cell, row) => {
            return (
                <>
                    <button
                        onClick={() => {
                            this.ShowMicroscopyStatusModal(row.id);
                        }}
                        data-toggle="tooltip"
                        title="Update Microscopy Result Status"
                        className="btn TableRow_btn"
                    >
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                    </button>
                    <p>{row.sampleMicroscopyStatus}</p>
                </>
            );
        };

        const TbNumber03 = (row) => {
            return (
                <>
                    <button
                        onClick={() => {
                            this.ChangeTbNumber03(row.id);
                        }}
                        data-toggle="tooltip"
                        title="Update Sample Status"
                        className="btn TableRow_btn"
                    >
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                    </button>
                    <p>{row.tbNumber_03}</p>
                </>
            );
        };

        const TbNumber05 = (row) => {
            return (
                <>
                    <button
                        onClick={() => {
                            this.ChangeTbNumber05(row.id);
                        }}
                        data-toggle="tooltip"
                        title="Update Sample Status"
                        className="btn TableRow_btn"
                    >
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                    </button>
                    <p>{row.tbNumber_05}</p>
                </>
            );
        };

        const CheckingResults = (row) => {
            if (
                (row.mtbResult || row.afbResult || row.rrResult) &&
                row.tbNumber_03 === null
            ) {
                return { backgroundColor: "#ffc6c4" };
            }
        };

        const columns = [
            {
                dataField: "id",
                text: "Id",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
            },
            {
                dataField: "assignmentId",
                text: "Job #",
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return <span>{cell == 0 ? "" : cell}</span>;
                },
                csvFormatter: (cell, row) => (cell == 0 ? "" : cell),
                sort: true,
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 8 ? false : true,
                csvExport: true,
            },
            {
                dataField: "previousAssignmentId",
                text: "Previous Job #",
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return (
                        <span>
                            {row.previousAssignmentId == row.assignmentId || row.previousAssignmentId == 0 ? '' : cell}
                        </span>
                    );
                },
                csvFormatter: (cell, row) =>
                    row.previousAssignmentId == row.assignmentId || row.previousAssignmentId == 0 ? '' : cell,
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },

            {
                dataField: "provinceName",
                text: "Province",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                formatter: (cell, row) => {
                    return <span>{row.provinceName}</span>;
                },
                csvFormatter: (cell, row) => (cell == 0 ? "" : cell),

                // hidden: this.props.UserAuthentication?.UserInfo?.roleId == 8 ? false : true,
                csvExport: true,
            },

            {
                dataField: "subRecipient_ShortName",
                text: "Sr Name",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                formatter: (cell, row) => {
                    return <span>{row.subRecipient_ShortName}</span>;
                },
                csvFormatter: (cell, row) => (cell == 0 ? "" : cell),

                // hidden: this.props.UserAuthentication?.UserInfo?.roleId == 8 ? false : true,
                csvExport: true,
            },

            {
                dataField: "districtName",
                text: "District",
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                sort: true,
                //tehsilName
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 8 ? false : true,
                csvExport: true,
            },


            //{
            //    dataField: "afbHcfDistrictName",
            //    text: "Afb Hcf District Name",
            //    style: (cell, row) => {
            //        return CheckingResults(row);
            //    },
            //    headerStyle: (colum, colIndex) => {
            //        return { width: "180px", fontSize: "13px" };
            //    },
            //    sort: true,
            //    csvExport: true,
            //},

            //{
            //    dataField: "afbXpDistrictName",
            //    text: "Afb Xp District Name",
            //    style: (cell, row) => {
            //        return CheckingResults(row);
            //    },
            //    headerStyle: (colum, colIndex) => {
            //        return { width: "180px", fontSize: "13px" };
            //    },
            //    sort: true,
            //    csvExport: true,
            //},

            //{
            //    dataField: "mtbXpDistrictName",
            //    text: "Mtb Xp District Name",
            //    style: (cell, row) => {
            //        return CheckingResults(row);
            //    },
            //    headerStyle: (colum, colIndex) => {
            //        return { width: "180px", fontSize: "13px" };
            //    },
            //    sort: true,
            //    csvExport: true,
            //},
            {
                dataField: "tehsilName",
                text: "Tehsil",
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                sort: true,
                //tehsilName
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 8 ? false : true,
                csvExport: true,
            },
            //{
            //	dataField: "sampleDateTime",
            //	text: "Created On",
            //	headerStyle: (colum, colIndex) => {
            //		return { width: "180px", fontSize: "13px" };
            //	},
            //	style: (cell, row) => {
            //		return CheckingResults(row);
            //	},
            //	sort: true,
            //	csvExport: true,
            //},
            {
                dataField: "category",
                text: "Category",
                headerStyle: (colum, colIndex) => {
                    return { width: "86px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },

            {
                dataField: "hcfName",
                text: "BHU/RHC",
                headerStyle: (colum, colIndex) => {
                    return { width: "130px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                // sort: true,
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 8 ? false : true,
                csvExport: true,
            },

            {
                dataField: "type",
                text: "Facility Type",
                headerStyle: (colum, colIndex) => {
                    return { width: "85px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                sort: true,
                // formatter: (cell, row) => {
                // 	return (
                // 		<span>
                // 			{cell == 1
                // 				? row.category === "public"
                // 					? "BHU"
                // 					: "GP"
                // 				: cell == 2
                // 				? row.category === "public"
                // 					? "RHC"
                // 					: "PPM"
                // 				: ""}
                // 		</span>
                // 	);
                // },
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 8 ? false : true, subtype
                csvExport: true,
            },

            {
                dataField: "subtype",
                text: "Route Type",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                formatter: (cell, row) => {
                    return (
                        <span>
                            {cell === 1
                                ? "BHU to RHC "
                                : cell === 2
                                    ? "RHC to Xpert "
                                    : cell === 3
                                        ? "BHU to Xpert "
                                        : cell}
                        </span>
                    );
                },
                csvFormatter: (typeId) =>
                    typeId === 1
                        ? "BHU to RHC "
                        : typeId === 2
                            ? "RHC to Xpert "
                            : typeId === 3
                                ? "BHU to Xpert "
                                : "",
            },

            {
                dataField: "referredBy",
                text: "Referred By",

                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },

            {
                dataField: "patientName",
                text: "Patient",
                formatter: (cell, row) => {
                    return avatarformatter(cell, row);
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                csvExport: true,
            },
            {
                dataField: "gender",
                text: "Gender",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return (
                        <span>{cell == 1 ? "Male" : cell == 2 ? "Female" : "Other"}</span>
                    );
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvFormatter: (gender) =>
                    gender == 1 ? "Male" : gender == 2 ? "Female" : "Other",
            },
            {
                dataField: "age",
                text: "Age",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvFormatter: (age) => (age == null ? "" : age),
            },

            {
                dataField: "afbResult",
                text: "AFB Result",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "85px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return AFBResultFormatter(cell, row);
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                // formatter:(cell, row)=>{return <span>{cell==1?"Negative":cell==2?"Positive":""}</span>},
                csvFormatter: (cell, row) =>
                    cell == 1 ? "Negative" : cell == 2 ? "Positive" : "",
            },
            {
                dataField: "noOfSlides",
                text: "# Slides",
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                // sort: true,
                csvExport: true,
            },
            {
                dataField: "afbResultType",
                text: "AFB Grading",
                // sort: true,
                formatter: (cell, row) => {
                    return (
                        <span>
                            {cell == 1
                                ? "Scanty"
                                : cell == 2
                                    ? "1+"
                                    : cell == 3
                                        ? "2+"
                                        : cell == 4
                                            ? "3+"
                                            : ""}
                        </span>
                    );
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvFormatter: (cell, row) =>
                    cell == 1
                        ? "Scanty"
                        : cell == 2
                            ? "1+"
                            : cell == 3
                                ? "2+"
                                : cell == 4
                                    ? "3+"
                                    : "",
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            // ,{
            //     dataField: 'XpertSiteName',
            //     text: 'Xpert Site',
            //     sort: true,
            // }
            // ,{
            //     dataField: 'RiderName',
            //     text: 'Rider',
            //     sort: true,
            // }
            {
                dataField: "sampleMicroscopyStatus",
                text: "Sample Quality",
                sort: true,
                formatter: (cell, row) => {
                    return MicroscopyFormatter(cell, row);
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },
            {
                dataField: "mtbResult",
                text: "MTB Result",
                // sort: true,
                // formatter:(cell, row)=>{return <span>{cell==1?"Invalid":cell==2?"Detected":cell==3?"Not Detected":cell==4?"Error":""}</span>},
                formatter: (cell, row) => {
                    return MTBResultFormatter(cell, row);
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvFormatter: (cell, row) =>
                    cell == 1
                        ? "Invalid"
                        : cell == 2
                            ? "Detected"
                            : cell == 3
                                ? "Not Detected"
                                : cell == 4
                                    ? "Error"
                                    : "",
                headerStyle: (colum, colIndex) => {
                    return { width: "140px", fontSize: "13px" };
                },
            },
            {
                dataField: "rrResult",
                text: "RR Result",
                // sort: true,
                formatter: (cell, row) => {
                    return (
                        <span>
                            {cell == 1
                                ? "Invalid"
                                : cell == 2
                                    ? "Detected"
                                    : cell == 3
                                        ? "Not Detected"
                                        : cell == 4
                                            ? "Indeterminate"
                                            : ""}
                        </span>
                    );
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvFormatter: (cell, row) =>
                    cell == 1
                        ? "Invalid"
                        : cell == 2
                            ? "Detected"
                            : cell == 3
                                ? "Not Detected"
                                : cell == 4
                                    ? "Indeterminate"
                                    : "",
                headerStyle: (colum, colIndex) => {
                    return { width: "140px", fontSize: "13px" };
                },
            },

            {
                dataField: "mtbDetailResult",
                text: "Mtb Value",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },

                formatter: (cell, row) => {
                    return (
                        <span>
                            {cell == 1
                                ? "High"
                                : cell == 2
                                    ? "Medium"
                                    : cell == 3
                                        ? "Low"
                                        : cell == 4
                                            ? "Very Low"
                                            : cell == 5
                                                ? "Trace"
                                                : cell}
                        </span>
                    );
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvFormatter: (mtbDetailResult) =>
                    mtbDetailResult == 1
                        ? "High"
                        : mtbDetailResult == 2
                            ? "Medium"
                            : mtbDetailResult == 3
                                ? "Low"
                                : mtbDetailResult == 4
                                    ? "Very Low"
                                    : mtbDetailResult == 5
                                        ? "Trace"
                                        : "",
            },

            {
                dataField: "isNegativeResultBypass",
                text:
                    "Requires RR & MTB test (despite negative microscopy result)".slice(
                        0,
                        12
                    ) + "",
                formatter: (cell, row) => {
                    return (
                        <span>
                            <input
                                type="checkbox"
                                disabled={
                                    row.mtbResult !== null &&
                                        row.mtbResult != "" &&
                                        row.mtbResult !== 0
                                        ? true
                                        : false
                                }
                                checked={cell == null ? false : cell == 1 ? true : false}
                                onClick={(e) => {
                                    this.HandleCheckboxChange(
                                        row.id,
                                        cell == null ? false : cell
                                    );
                                }}
                            />
                        </span>
                    );
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
                csvExport: true,
            },
            {
                dataField: "sampleStatus",
                text: "Sample Time",
                formatter: (cell, row) => {
                    return SampleStatusFormatter(row.id, row.sampleStatus);
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "135px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },
            {
                dataField: "isfollowUpCase",
                text: "Follow Up",
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },

                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },
            {
                dataField: "tbNumber_03",
                text: "TB Number 03",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return TbNumber03(row);
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
            },
            {
                dataField: "tbNumber_05",
                text: "TB Number 05",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return TbNumber05(row);
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
            },

            {
                dataField: "afbperformedbyHCF",
                text: "AFB Perform By HCF",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
            },

            {
                dataField: "afbperformedbyXpert",
                text: "AFB Perform By Xpert",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
            },

            {
                dataField: "mtbperformedbyXpert",
                text: "MTB Perform By Xpert",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
            },

            {
                dataField: "afbperformedbyUsername",
                text: "AFB Performeded By",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },

            {
                dataField: "mtbperformedbyUsername",
                text: "MTB Performed By",
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                csvExport: true,
            },

            {
                dataField: "sampleDateTime",
                text: "Sample Date",
                headerStyle: (colum, colIndex) => {
                    return { width: "180px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                sort: true,
                csvExport: true,
            },

            {
                dataField: "afbResultDateTime",
                text: "AFB Result Date",
                headerStyle: (colum, colIndex) => {
                    return { width: "180px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                formatter: (cell, row) => {
                    return Common.ConvertToLocalDateTime(cell);
                },
                csvFormatter: (afbResultDateTime) =>
                    Common.ConvertToLocalDateTime(afbResultDateTime),
                sort: true,
            },

            {
                dataField: "resultDateTime",
                text: "MTB Result Date",
                headerStyle: (colum, colIndex) => {
                    return { width: "180px", fontSize: "13px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                formatter: (cell, row) => {
                    return Common.ConvertToLocalDateTime(cell);
                },
                csvFormatter: (resultDateTime) =>
                    Common.ConvertToLocalDateTime(resultDateTime),
                sort: true,
            },



            {
                dataField: "",
                text: "Actions",
                headerStyle: (colum, colIndex) => {
                    return { width: "75px" };
                },
                style: (cell, row) => {
                    return CheckingResults(row);
                },
                formatter: (cell, row) => {
                    return CellMenu(cell, row);
                },
                csvExport: false,
                // hidden: this.props.UserAuthentication.UserInfo?.roleId == 1 || this.props.UserAuthentication.UserInfo?.roleId == 8 ? true : false
            },
        ];



        console.log("role", this.props.UserAuthentication.UserInfo?.roleId);
        return (
            <div>
                <AlertModal {...this.state.alertModalData} />
                {/* -------------------Update Status-------- */}
                <button
                    id="UpdateAfbStatusModal_btn"
                    style={{ display: "none" }}
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#UpdateAfbStatus_Modal"
                >
                    Large modal
                </button>
                <div
                    class="modal fade"
                    id="UpdateAfbStatus_Modal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="addappTitle"
                    aria-hidden="true"
                >
                    <div
                        class="modal-dialog modal-dialog-centered"
                        role="document"
                        style={{ maxWidth: "500px" }}
                    >
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="ModalTopClose_btn">
                                    <span
                                        style={{ cursor: "pointer" }}
                                        id="UpdateAfbStatusModal_Closebtn"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                    >
                                        x
                                    </span>
                                </div>
                                <h5
                                    class="modal-title"
                                    id="exampleModalLongTitle"
                                    style={{ fontSize: "17px", fontWeight: "700" }}
                                >
                                    Enter Sample Result
                                </h5>
                                {/* <i class="fa fa-times-circle appointmentdetailcross" id="UpdateStatusModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
                            </div>

                            <div class="modal-body">
                                <form
                                    onSubmit={
                                        this.props.UserAuthentication.UserInfo?.roleId == 3
                                            ? this.SaveAfbResultXpert
                                            : this.SaveAfbResultNormal
                                    }
                                    novalidate
                                >
                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for="">AFB Result</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={false}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="AFBId"
                                            options={this.state.AFBlist}
                                            val={this.state.AFBId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="">No. of Slides</label>
                                        <select
                                            className="form-control"
                                            onChange={(event) =>
                                                this.setState({
                                                    noOfSlides: event.target.value,
                                                })
                                            }
                                        >
                                            <option value="0">Select No. of slides</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                        </select>
                                    </div>

                                    <div
                                        class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                        hidden={this.state.AFBId === 2 ? false : true}
                                    >
                                        <label for="">AFB Grading</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={false}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="AFBTypeId"
                                            options={this.state.AFBTypelist}
                                            val={this.state.AFBTypeId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="isfollowUpCase">
                                            <input
                                                id="isfollowUpCase"
                                                type="checkbox"
                                                checked={this.state.isfollowUpCase}
                                                onChange={() =>
                                                    this.setState({
                                                        isfollowUpCase: !this.state.isfollowUpCase,
                                                    })
                                                }
                                            />
                                            {"  "}Follow up this
                                        </label>
                                    </div>
                                    <br />

                                    <div
                                        class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3"
                                        hidden={this.state.AFBId === 1 ? false : true}
                                    >
                                        <label htmlFor="isNegativeResult">
                                            <input
                                                id="isNegativeResult"
                                                type="checkbox"
                                                checked={this.state.isNegativeResult}
                                                onChange={() =>
                                                    this.setState({
                                                        isNegativeResult: !this.state.isNegativeResult,
                                                    })
                                                }
                                            />
                                            {"  "}Send for MTB Test
                                        </label>
                                    </div>

                                    <div
                                        style={{
                                            float: "right",
                                            marginRight: "15px",
                                            marginTop: "35px",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            class="btn btn_style3"
                                            data-dismiss="modal"
                                            aria-hidden="true"
                                        >
                                            CANCEL
                                        </button>
                                        <button type="submit" class="btn btn_style1">
                                            SAVE
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Sample status Modal */}
                <button
                    id="ChangeSampleStatusModal_btn"
                    style={{ display: "none" }}
                    type="button"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#ChangeSampleStatusModal"
                >
                    Large modal
                </button>
                <div
                    className="modal fade"
                    id="ChangeSampleStatusModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="addappTitle"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                        style={{ maxWidth: "500px" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="ModalTopClose_btn">
                                    <span
                                        style={{ cursor: "pointer" }}
                                        id="ChangeSampleStatusModal_closebtn"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                    >
                                        x
                                    </span>
                                </div>
                                <h5
                                    className="modal-title"
                                    id="exampleModalLongTitle"
                                    style={{ fontSize: "17px", fontWeight: "700" }}
                                >
                                    Enter Sample Result
                                </h5>
                                {/* <i class="fa fa-times-circle appointmentdetailcross" id="UpdateStatusModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
                            </div>

                            <div className="modal-body">
                                <form onSubmit={this.SaveSampleStatus} noValidate>
                                    <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="">Sample Status</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={false}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="SampleStatus"
                                            options={this.state.PatientSampleStatus}
                                            val={this.state.SampleStatus}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div
                                        style={{
                                            float: "right",
                                            marginRight: "15px",
                                            marginTop: "35px",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn_style3"
                                            data-dismiss="modal"
                                            aria-hidden="true"
                                        >
                                            CANCEL
                                        </button>
                                        <button type="submit" className="btn btn_style1">
                                            SAVE
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/*TB Number*/}
                <button
                    id="ChangeTbNumberModal_btn"
                    style={{ display: "none" }}
                    type="button"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#ChangeTbNumberModal"
                >
                    Large modal
                </button>
                <div
                    className="modal fade"
                    id="ChangeTbNumberModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="addappTitle"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                        style={{ maxWidth: "500px" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="ModalTopClose_btn">
                                    <span
                                        style={{ cursor: "pointer" }}
                                        id="ChangeSampleStatusModal_closebtn"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                    >
                                        x
                                    </span>
                                </div>
                                <h5
                                    className="modal-title"
                                    id="exampleModalLongTitle"
                                    style={{
                                        fontSize: "17px",
                                        fontWeight: "700",
                                    }}
                                >
                                    Enter{" "}
                                    {this.state.tbNumber === 3 ? "TB Number 03" : "TB Number 05"}
                                </h5>
                                {/* <i class="fa fa-times-circle appointmentdetailcross" id="UpdateStatusModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
                            </div>

                            <div className="modal-body">
                                <form onSubmit={this.UpdateTBNumber} noValidate>
                                    <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="">
                                            {this.state.tbNumber === 3
                                                ? "TB Number 03"
                                                : "TB Number 05"}
                                        </label>
                                        <input type="text" id="tbNumber" className="form-control" />
                                    </div>

                                    <div
                                        style={{
                                            float: "right",
                                            marginRight: "15px",
                                            marginTop: "35px",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn_style3"
                                            data-dismiss="modal"
                                            aria-hidden="true"
                                        >
                                            CANCEL
                                        </button>
                                        <button type="submit" className="btn btn_style1">
                                            SAVE
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Update Microscopy Model*/}
                <button
                    id="UpdateMicroscopyModal_btn"
                    style={{ display: "none" }}
                    type="button"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#UpdateMicroscopyModal"
                >
                    Large modal
                </button>
                <div
                    className="modal fade"
                    id="UpdateMicroscopyModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="addappTitle"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                        style={{ maxWidth: "500px" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="ModalTopClose_btn">
                                    <span
                                        style={{ cursor: "pointer" }}
                                        id="ChangeSampleStatusModal_closebtn"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                    >
                                        x
                                    </span>
                                </div>
                                <h5
                                    className="modal-title"
                                    id="exampleModalLongTitle"
                                    style={{ fontSize: "17px", fontWeight: "700" }}
                                >
                                    Enter Microscopy Status
                                </h5>
                                {/* <i class="fa fa-times-circle appointmentdetailcross" id="UpdateStatusModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
                            </div>

                            <div className="modal-body">
                                <form onSubmit={this.UpdateMicroscopyStatus} noValidate>
                                    <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="">Microscopy Status</label>
                                        <select
                                            name=""
                                            className="form-control"
                                            id="MicroscopyStatus"
                                        >
                                            <option value="insufficient">Insufficient</option>
                                            <option value="inappropriate">Inappropriate</option>
                                        </select>
                                    </div>

                                    <div
                                        style={{
                                            float: "right",
                                            marginRight: "15px",
                                            marginTop: "35px",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn_style3"
                                            data-dismiss="modal"
                                            aria-hidden="true"
                                        >
                                            CANCEL
                                        </button>
                                        <button type="submit" className="btn btn_style1">
                                            SAVE
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* -------------------Update MTB Status-------- */}
                <button
                    id="UpdateStatusModal_btn"
                    style={{ display: "none" }}
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#UpdateStatus_Modal"
                >
                    Large modal
                </button>
                <div
                    class="modal fade"
                    id="UpdateStatus_Modal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="addappTitle"
                    aria-hidden="true"
                >
                    <div
                        class="modal-dialog modal-dialog-centered"
                        role="document"
                        style={{ maxWidth: "500px" }}
                    >
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="ModalTopClose_btn">
                                    <span
                                        style={{ cursor: "pointer" }}
                                        id="UpdateStatusModal_Closebtn"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                    >
                                        x
                                    </span>
                                </div>
                                <h5
                                    class="modal-title"
                                    id=""
                                    style={{ fontSize: "17px", fontWeight: "700" }}
                                >
                                    Enter Sample Result
                                </h5>
                                {/* <i class="fa fa-times-circle appointmentdetailcross" id="UpdateStatusModal_Closebtn" data-dismiss="modal" aria-hidden="true"></i> */}
                            </div>

                            <div class="modal-body">
                                <form onSubmit={this.SaveMTBResultStatus} novalidate>
                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for="">MTB</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={false}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="MTBId"
                                            options={this.state.MTBlist}
                                            val={this.state.MTBId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div>

                                    {this.state.MTBId === 2 && (
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">MTB Rating</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="MTBRatingId"
                                                options={this.state.MTBRatingList}
                                                val={this.state.MTBRatingId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select MTB Rating"
                                            />
                                        </div>
                                    )}

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for="">RR</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={false}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="RRId"
                                            options={this.state.RRlist}
                                            val={this.state.RRId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={false}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label for="">Description</label>
                                        <textarea
                                            class="form-control"
                                            id="Status_Description"
                                            rows="3"
                                        ></textarea>
                                    </div>

                                    <div
                                        style={{
                                            float: "right",
                                            marginRight: "15px",
                                            marginTop: "35px",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            class="btn btn_style3"
                                            data-dismiss="modal"
                                            aria-hidden="true"
                                        >
                                            CANCEL
                                        </button>
                                        <button type="submit" class="btn btn_style1">
                                            SAVE
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <AlertModal {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" class="right-panel">
                    <Topmenu
                        PageTitle="Patient Samples"
                        isShowAddBtn={this.state.permissions.includes("patientsamples-add")}
                        AddBtnLabel="Add Patient Sample"
                        AddBtnLink="/PatientSample_Add"
                    />
                    <div class="content">
                        <div class="card">
                            <div class="card-body">
                                <div className="Table_Search row">
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Province</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="ProvinceId"
                                            options={this.state.Provincelist}
                                            val={this.state.ProvinceId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.ProvinceLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Sub Recipient</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="SrId"
                                            options={this.state.FilteredSrs}
                                            val={this.state.SrId}
                                            addPlaceholder=""
                                            disabled={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">District</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="DistrictId"
                                            options={this.state.FilteredDistrictlist}
                                            val={this.state.DistrictId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.DistrictLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Sample #</label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control Search_InputField"
                                            id="SearchId"
                                            placeholder="Sample Id"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Patient Name</label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control Search_InputField"
                                            id="SearchName"
                                            placeholder="Patient Name"
                                        />
                                    </div>
                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Patient Contact</label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control Search_InputField"
                                            id="SearchContact"
                                            placeholder="Patient Contact"
                                        />
                                    </div>

                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">AFB Result</label>
                                        <select id="afbResult" className="form-control">
                                            <option value="">All</option>
                                            <option value="1">Negative</option>
                                            <option value="2">Positive</option>
                                        </select>
                                    </div>
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">RR Result</label>
                                        <select id="rr" className="form-control">
                                            <option value="">All</option>
                                            <option value="1">Invalid</option>
                                            <option value="2">Detected</option>
                                            <option value="3">Not Detected</option>
                                            <option value="4">Indeterminate</option>
                                        </select>
                                    </div>
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">MTB Result</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="MTBResultId"
                                            options={this.state.MTBlist}
                                            val={this.state.MTBResultId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Type</label>
                                        <DropDown
                                            multi={true}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="HCFTypeId"
                                            options={this.state.HCFTypelist}
                                            val={this.state.HCFTypeId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={false}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    {/* <div className="ormInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Category
										</label>
										<select
											className="form-control"
											onChange={(event) =>
												this.setState({
													category: event.target.value,
												})
											}
										>
											<option value="">All</option>
											<option value="public">Public</option>
											<option value="private">Private</option>
										</select>
									</div> */}

                                    <div className="ormInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">
                                            <span style={{ color: "red" }}>* </span>Job Assignments
                                        </label>
                                        <select className="form-control" id="assignment">
                                            <option value="">All</option>
                                            <option value="0">Not Assigned Results</option>
                                            <option value="1">Job Assigned Results</option>
                                        </select>
                                    </div>
                                    <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Gender</label>
                                        <select id="gender" className="form-control">
                                            <option value="">All</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </select>
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">From</label>
                                        <DatePicker
                                            selected={this.state.startDate}
                                            onChange={(date) => {
                                                this.HandleDateChange("startDate", date);
                                            }}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">To</label>
                                        <DatePicker
                                            selected={this.state.endDate}
                                            onChange={(date) => {
                                                this.HandleDateChange("endDate", date);
                                            }}
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            minDate={this.state.startDate}
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12" hidden>
                                        <div><label htmlFor="">Include Date</label></div>
                                        <div>
                                            <input
                                                className="form-control"
                                                style={{ height: "1px", minHeight: "auto", opacity: 0 }}
                                            />

                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="checkbox" id="CheckBoxSampleDate" onChange={() => this.handleIncludeDateCheckboxChange('SampleDate')} />
                                                <label class="form-check-label" for="CheckBoxSampleDate">Sample Date</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="checkbox" id="CheckBoxAfbDate" onChange={() => this.handleIncludeDateCheckboxChange('AfbDate')} />
                                                <label class="form-check-label" for="CheckBoxAfbDate">Afb Date</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="checkbox" id="CheckBoxResultDate" onChange={() => this.handleIncludeDateCheckboxChange('ResultDate')} />
                                                <label class="form-check-label" for="CheckBoxResultDate">Result Date</label>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label htmlFor="">Job Id</label>
                                        <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control Search_InputField"
                                            id="JobId"
                                            placeholder="Job Id"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <label
                                            className="checkboxesinputs"
                                            style={{
                                                position: "relative",
                                                marginTop: 45,
                                                marginRight: 10,
                                            }}
                                        >
                                            <input
                                                className="NodeCheckbox_input"
                                                type="checkbox"
                                                checked={this.state.filterByCompletionDate}
                                                onChange={(e) => {
                                                    this.setState({
                                                        filterByCompletionDate: e.target.checked,
                                                    });
                                                }}
                                            />
                                            <span className="checkmark"></span>
                                            <span
                                                style={{
                                                    fontWeight: "100",
                                                    color: "black",
                                                }}
                                            >
                                                Filter by Completion Date
                                            </span>
                                        </label>
                                        <button
                                            onClick={() => {
                                                this.PopulateTable();
                                            }}
                                            id="FormSearchBtn"
                                            className={"btn btn-primary"}
                                            style={{ position: "relative", marginTop: 35 }}
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>

                                {this.state.csvFileLink && (
                                    <p>
                                        <a
                                            id="btnDownload"
                                            href={this.state.csvFileLink}
                                            download="sheet.csv"
                                            onClick={() => {
                                                setTimeout(() => {
                                                    this.setState({ csvFileLink: null });
                                                }, 1000);
                                            }}
                                        >
                                            Download CSV File
                                        </a>
                                    </p>
                                )}

                                <div style={{ whiteSpace: "nowrap" }}>
                                    <Table
                                        keyField="id"
                                        data={this.state.data}
                                        page={this.state.page}
                                        sizePerPage={this.state.sizePerPage}
                                        totalSize={this.state.TotalRecord}
                                        onTableChange={this.handleTableChange}
                                        changeSizePerPage={(size) => {
                                            setTimeout(() => {
                                                this.setState({
                                                    exportLoading: true,
                                                });
                                                this.ExportData(size);
                                            }, 100);
                                        }}
                                        exportAllowed={this.state.permissions.includes(
                                            "patientsamples-export"
                                        )}
                                        isPagination={true}
                                        exportLoading={this.state.ExportLoading}
                                        pdfExportLoading={this.state.ExportLoadingPdf}
                                        exportPdf={this.ExportPdf}
                                        columns={columns}
                                        loading={this.state.loading}
                                        RefreshTable={this.PopulateTable}
                                    /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login");
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_PatientSamples");
        this.GetPageConfigData(() => {
            this.PopulateTable();
        });
        $(".Search_InputField").on("keypress", (e) => {
            if (e.which === 13) {
                this.PopulateTable();
            }
        });

        this.SelectSubReciepents();

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_RolesPermissions,
            {
                pageSize: 15,
                pageNumber: 1,
            },
            (resp) => {
                const modifiedPermissions = resp.data
                    .filter(
                        (p) =>
                            p.permissioN_GROUP === "PatientSamples" && p.permissioN_ALLOWED
                    )
                    .map((d) => d.permissioN_NAME);
                this.setState({ permissions: modifiedPermissions });
            }
        );
    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true });
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        var d4 = $.Deferred();
        var d5 = $.Deferred();
        // var d6= $.Deferred();
        this.SelectHCF(() => {
            d1.resolve();
        });
        this.SelectPatients(() => {
            d2.resolve();
        });
        this.SelectRiders(() => {
            d3.resolve();
        });
        this.SelectDistricts(() => {
            d4.resolve();
        });
        this.SelectProvinces(() => {
            d5.resolve();
        });
        // this.SelectXpertSites(()=>{d6.resolve()})
        $.when(d1, d2, d3, d4, d5).done(() => {
            this.props.ShowLoader({ Isloading: false });
            CallBack();
        });
    };
    SelectSubReciepents = () => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectALl_SubRecipient,
            {},
            (resp) => {
                if (resp.status) {
                    this.setState({
                        SrList: resp.data.map((d) => ({
                            id: d.id,
                            name: d.short_name,
                            districtId: d.districtid,
                            ...d,
                        })),
                    });
                }
            }
        );
    };
    SelectPatients = (Callback) => {
        SelectAllPatients(
            (data) => {
                this.setState({
                    Patientslist: data,
                });
                Callback();
            },
            (error) => {
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectRiders = (Callback) => {
        SelectAllRiders(
            (data) => {
                this.setState({
                    Riderslist: data,
                });
                Callback();
            },
            (error) => {
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectProvinces = (Callback) => {
        this.setState({ ProvinceLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Province,
            {},
            (data) => {
                this.setState({
                    ProvinceLoader: false,
                    Provincelist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ ProvinceLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_District,
            {},
            (data) => {
                this.setState({
                    DistrictLoader: false,
                    Districtlist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ DistrictLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectXpertSites = (Callback) => {
        this.setState({ XpertSiteLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_XpertSites,
            {},
            (data) => {
                this.setState({
                    XpertSiteLoader: false,
                    XpertSitelist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ XpertSiteLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectHCF = (Callback) => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_HCF,
            {},
            (data) => {
                this.setState({
                    HCFlist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ DistrictLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "sort") {
            let tempFieldorderLabel = sortField + "sortOrder";
            let tempFieldorder =
                this.state[tempFieldorderLabel] === ""
                    ? sortOrder
                    : this.state[tempFieldorderLabel] === "asc"
                        ? "desc"
                        : "asc";
            this.setState(
                {
                    sortField,
                    [tempFieldorderLabel]: tempFieldorder,
                },
                () => {
                    this.PopulateTable();
                }
            );
            return;
        }
        this.setState(
            {
                page,
                sizePerPage,
            },
            () => {
                this.PopulateTable();
            }
        );
    };
    ExportPdf = () => {
        this.setState({
            ExportLoadingPdf: true,
        });

        const doc = new jsPDF();
        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";
        var mtbResultString =
            this.state.MTBResultId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.MTBResultId, "id") + ",";
        var hcfTypeString =
            this.state.HCFTypeId.length === 0
                ? ""
                : "," + this.state.HCFTypeId.map(item => item.id.charAt(0)).join(",") + ",";

        var Parameters = {
            Id: $("#SearchId").val(),
            jobId: $("#JobId").val(),
            includeSampleDate: $("#CheckBoxSampleDate").prop('checked'),
            includeAfbDate: $("#CheckBoxAfbDate").prop('checked'),
            includeResultDate: $("#CheckBoxResultDate").prop('checked'),
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            provinceId: provinceIdString,
            districtId: districtIdString,
            category: this.state.HCFTypeId.length > 0 ? this.state.category : "",
            facilityType: hcfTypeString,
            afbResult: $("#afbResult").val() === "" ? null : $("#afbResult").val(),
            rrResult: $("#rr").val() === "" ? null : $("#rr").val(),
            mtbResult: mtbResultString,
            gender: $("#gender").val() === "" ? null : $("#gender").val(),
            jobAssignment:
                $("#assignment").val() === "" ? null : $("#assignment").val(),
            // subrecipientId: this.state.SrId,
            subRecipientIdString,
            filterByCompletionDate: this.state.filterByCompletionDate,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTime(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_PatientSamples,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    doc.autoTable({
                        theme: "grid",
                        body: [...resp.data],
                        columns: [
                            { header: "id", dataKey: "id" },
                            { header: "AssignmentID", dataKey: "assignmentId" },
                            { header: "HCF Type", dataKey: "hcfType" },
                            { header: "Patient Name", dataKey: "patientName" },
                            { header: "Gender", dataKey: "gender" },
                            { header: "Category", dataKey: "category" },
                            { header: "Age", dataKey: "age" },
                            { header: "TB Number05", dataKey: "tbNumber_05" },
                            { header: "TB Number03", dataKey: "tbNumber_03" },
                            { header: "AFB Result", dataKey: "afbResult" },
                            { header: "Status", dataKey: "sampleStatus" },
                            { header: "Province", dataKey: "provinceName" },
                            { header: "Tehsil", dataKey: "tehsilName" },
                            { header: "AFB Type", dataKey: "afbResultType" },
                            { header: "District", dataKey: "districtName" },
                            { header: "MTB Result", dataKey: "mtbResult" },
                            { header: "RR Result", dataKey: "rrResult" },
                            { header: "Sample Date", dataKey: "sampleDateTime" },
                            { header: "AFB Result Date", dataKey: "afbResultDateTime" },
                            { header: "MTB Result Date", dataKey: "resultDateTime" },
                        ],
                    });
                    this.setState({
                        ExportLoadingPdf: false,
                    });
                    doc.save("samples.pdf");
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ExportData = () => {
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ ExportLoading: true, loading: true });
        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";
        var mtbResultString =
            this.state.MTBResultId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.MTBResultId, "id") + ",";
        var hcfTypeString =
            this.state.HCFTypeId.length === 0
                ? ""
                : "," + this.state.HCFTypeId.map(item => item.id.charAt(0)).join(",") + ",";
        var Parameters = {
            Id: $("#SearchId").val(),
            jobId: $("#JobId").val(),
            includeSampleDate: $("#CheckBoxSampleDate").prop('checked'),
            includeAfbDate: $("#CheckBoxAfbDate").prop('checked'),
            includeResultDate: $("#CheckBoxResultDate").prop('checked'),
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            provinceId: provinceIdString,
            districtId: districtIdString,
            category: this.state.HCFTypeId.length > 0 ? this.state.category : "",
            facilityType: hcfTypeString,
            afbResult: $("#afbResult").val() === "" ? null : $("#afbResult").val(),
            rrResult: $("#rr").val() === "" ? null : $("#rr").val(),
            mtbResult: mtbResultString,
            gender: $("#gender").val() === "" ? null : $("#gender").val(),
            jobAssignment:
                $("#assignment").val() === "" ? null : $("#assignment").val(),
            subRecipientIdString,
            filterByCompletionDate: this.state.filterByCompletionDate,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_PatientSamples_Download,
            Parameters,
            (resp) => {
                console.log("Export Data Response", resp);
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({
                    loading: false,
                    ExportLoading: false,
                    csvFileLink: Common.BaseUrlAPI + resp.csvFileLink,
                    exportLoading: false,
                });
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({
                    loading: false,
                    ExportLoading: false,
                });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    PopulateTable = (tableLoading = true) => {
        console.log(this.props.UserAuthentication);
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({
            loading: tableLoading,
            TotalRecord: 0,
        });

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";
        var mtbResultString =
            this.state.MTBResultId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.MTBResultId, "id") + ",";
        var hcfTypeString =
            this.state.HCFTypeId.length === 0
                ? ""
                : "," + this.state.HCFTypeId.map(item => item.id.charAt(0)).join(",") + ",";

        var Parameters = {
            Id: $("#SearchId").val(),
            jobId: $("#JobId").val(),
            includeSampleDate: $("#CheckBoxSampleDate").prop('checked'),
            includeAfbDate: $("#CheckBoxAfbDate").prop('checked'),
            includeResultDate: $("#CheckBoxResultDate").prop('checked'),
            name: $("#SearchName").val(),
            contact: $("#SearchContact").val(),
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            provinceId: provinceIdString,
            districtId: districtIdString,
            category: this.state.HCFTypeId.length > 0 ? this.state.category : "",
            facilityType: hcfTypeString,
            afbResult: $("#afbResult").val() === "" ? null : $("#afbResult").val(),
            rrResult: $("#rr").val() === "" ? null : $("#rr").val(),
            mtbResult: mtbResultString,
            gender: $("#gender").val() === "" ? null : $("#gender").val(),
            jobAssignment:
                $("#assignment").val() === "" ? null : $("#assignment").val(),
            subRecipientIdString,
            filterByCompletionDate: this.state.filterByCompletionDate,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_PatientSamples,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    var ProcessedHcf = Common.ProcessDataInArray(
                        this.state.HCFList,
                        "id"
                    );
                    for (var i in resp.data) {
                        resp.data[i].hcfType = ProcessedHcf[resp.data[i].hfcId]?.typeId;
                        resp.data[i].sampleDateTime = Common.ConvertToLocalDateTime(
                            resp.data[i].sampleDateTime
                        );
                        resp.data[i].type =
                            resp.data[i].type == 1
                                ? resp.data[i].category === "public"
                                    ? "BHU"
                                    : "GP"
                                : resp.data[i].type == 2
                                    ? resp.data[i].category === "public"
                                        ? "RHC"
                                        : "PPM"
                                    : "";
                    }
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.totalRecord,
                    });
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    onDelete = (id, assignmentId) => {
        let message =
            assignmentId == "" || assignmentId == null || assignmentId == 0
                ? "Are you sure you want to delete this record."
                : "Job# " +
                assignmentId +
                " will be modified, are you sure you want to delete this record.";
        this.setState(
            {
                alertModalData: {
                    title: "Need Confirmation",
                    message: message,
                    First_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                        this.DeleteRecord(id, assignmentId);
                    },
                    Second_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                    },
                    type: 1,
                },
            },
            () => {
                $("#Show_ArletModal").click();
            }
        );
    };
    DeleteRecord = (id, assignmentId) => {
        this.props.ShowLoader({ Isloading: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Delete_PatientSample,
            {
                id: id,
                assignmentId: assignmentId,
            },
            (Result) => {
                if (Result.status) {
                    this.PopulateTable();
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                    // SyncConfig(()=>{
                    //     this.PopulateTable()
                    //     this.props.ShowLoader({Isloading:false})
                    //     this.props.ShowAlert({Type:1,Msg:"Deleted Successfully."})
                    //     setTimeout(function(){$("#Alertmsgbtn").click()}, 50);
                    //   },()=>{
                    //     this.props.ShowLoader({Isloading:false})
                    //     this.props.ShowAlert({Type:0,Msg:"Error in sync, please reload the page"})
                    //     setTimeout(function(){$("#Alertmsgbtn").click()}, 50);
                    // })
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: Result.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ShowSampleStatusModal = (id) => {
        this.setState({
            SampleId: id,
            AFBId: 0,
            AFBTypeId: 0,
            isNegativeResult: false,
        });
        $("#UpdateAfbStatusModal_btn").click();
    };
    ChangeSampleStatusModal = (id, status) => {
        this.setState({
            SampleId: id,
        });
        $("#ChangeSampleStatusModal_btn").click();
    };
    ChangeTbNumber03 = (id) => {
        this.setState({
            SampleId: id,
            tbNumber: 3,
        });
        $("#ChangeTbNumberModal_btn").click();
    };
    ChangeTbNumber05 = (id) => {
        this.setState({
            SampleId: id,
            tbNumber: 5,
        });
        $("#ChangeTbNumberModal_btn").click();
    };
    SaveSampleStatus = (event) => {
        event.preventDefault();
        const selectedStatus = this.state.PatientSampleStatus.find(
            (d) => d.id === this.state.SampleStatus
        ).name;
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "POST",
            false,
            Common.BaseUrlAPI +
            `/api/PatientSamples/UpdateSampleStatus?sample_id=${this.state.SampleId}&sampleStatus=${selectedStatus}`,
            {},
            (resp) => {
                if (resp.status) {
                    this.PopulateTable();
                    $("#ChangeSampleStatusModal_btn").click();
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };
    UpdateTBNumber = (event) => {
        event.preventDefault();
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "POST",
            false,
            this.state.tbNumber === 3
                ? Common.BaseUrlAPI +
                `/api/PatientSamples/UpdateSampleTB03?sample_id=${this.state.SampleId
                }&tbNumber_03=${$("#tbNumber").val()}`
                : Common.BaseUrlAPI +
                `/api/PatientSamples/UpdateSampleTB05?sample_id=${this.state.SampleId
                }&tbNumber_05=${$("#tbNumber").val()}`,
            {},
            (resp) => {
                if (resp.status) {
                    this.PopulateTable();
                    $("#tbNumber").val("");
                    $("#ChangeTbNumberModal_btn").click();
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };
    // UpdateTBNumber05 = (event) => {
    //     event.preventDefault()
    //     Common.Ajax(this.props.UserAuthentication.AuthToken, 'POST', false, Common.BaseUrlAPI+`/api/PatientSamples/UpdateSampleTB05?sample_id=${this.state.SampleId}&tbNumber_05=${$('#tbNumber').val()}`, {}, (resp) => {
    //         if(resp.status) {
    //             this.PopulateTable()
    //             $("#ChangeTbNumberModal_btn").click()
    //         }
    //     }, (error) => {
    //         console.log(error)
    //     })
    // }
    SaveResultStatus = (e) => {
        // if (this.props.UserAuthentication.UserInfo?.roleId == 3 ) {
        // 	this.SaveAfbResultXpert();
        //   }
        //   else {
        // 	this.SaveAfbResultNormal();
        //   }
    };

    SaveAfbResultXpert = (e) => {
        e.preventDefault();
        if (this.state.AFBId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: "AFB result is required" });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }
        if (this.state.AFBId === 2 && this.state.AFBTypeId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: "AFB grading is required" });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }

        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            id: this.state.SampleId,
            afbResult: this.state.AFBId,
            noOfSlides: this.state.noOfSlides,
            afbResultType: this.state.AFBId === 2 ? this.state.AFBTypeId : null,
            isfollowUpCase: this.state.isfollowUpCase,
            isNegativeResultByPass: this.state.isNegativeResult,
            afbperformedby: this.props.UserAuthentication.UserInfo?.id,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Save_AfbResult_Xpert,
            Parameters,
            (resp) => {
                if (resp.status === true) {
                    SyncConfig(
                        () => {
                            this.setState({
                                SampleId: 0,
                                AFBId: 0,
                                afbResultType: 0,
                                isNegativeResult: false,
                            });
                            $("#UpdateAfbStatusModal_Closebtn").click();
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
                            setTimeout(() => {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        },
                        () => {
                            this.setState({
                                SampleId: 0,
                                AFBId: 0,
                                afbResultType: 0,
                                isNegativeResult: false,
                            });
                            $("#UpdateAfbStatusModal_Closebtn").click();
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: "Error in sync, please reload the page",
                            });
                            setTimeout(function () {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        }
                    );
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    SaveAfbResultNormal = (e) => {
        e.preventDefault();
        if (this.state.AFBId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: "AFB result is required" });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }
        if (this.state.AFBId === 2 && this.state.AFBTypeId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: "AFB grading is required" });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }

        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            id: this.state.SampleId,
            afbResult: this.state.AFBId,
            noOfSlides: this.state.noOfSlides,
            afbResultType: this.state.AFBId === 2 ? this.state.AFBTypeId : null,
            isfollowUpCase: this.state.isfollowUpCase,
            isNegativeResultByPass: this.state.isNegativeResult,
            afbperformedby: this.props.UserAuthentication.UserInfo?.id,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Save_AfbResult,
            Parameters,
            (resp) => {
                if (resp.status === true) {
                    SyncConfig(
                        () => {
                            this.setState({
                                SampleId: 0,
                                AFBId: 0,
                                afbResultType: 0,
                                isNegativeResult: false,
                            });
                            $("#UpdateAfbStatusModal_Closebtn").click();
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
                            setTimeout(() => {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        },
                        () => {
                            this.setState({
                                SampleId: 0,
                                AFBId: 0,
                                afbResultType: 0,
                                isNegativeResult: false,
                            });
                            $("#UpdateAfbStatusModal_Closebtn").click();
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: "Error in sync, please reload the page",
                            });
                            setTimeout(function () {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        }
                    );
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    HandleCheckboxChange = (sampleId, isNegativeResultBypass) => {
        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            sampleId: sampleId,
            isNegativeResultBypass: !isNegativeResultBypass,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Update_SampleNegativeResultBypassStatus,
            Parameters,
            (resp) => {
                if (resp.status) {
                    if (
                        this.props.UserAuthentication.UserInfo?.roleId == 1 ||
                        this.props.UserAuthentication.UserInfo?.roleId == 8
                    ) {
                        this.PopulateTable(false);
                        this.props.ShowLoader({ Isloading: false });
                        this.props.ShowAlert({ Type: 1, Msg: "Updated Successfully." });
                        setTimeout(function () {
                            $("#Alertmsgbtn").click();
                        }, 50);
                    } else {
                        SyncConfig(
                            () => {
                                this.PopulateTable();
                                this.props.ShowLoader({ Isloading: false });
                                this.props.ShowAlert({ Type: 1, Msg: "Updated Successfully." });
                                setTimeout(function () {
                                    $("#Alertmsgbtn").click();
                                }, 50);
                            },
                            () => {
                                this.props.ShowLoader({ Isloading: false });
                                this.props.ShowAlert({
                                    Type: 0,
                                    Msg: "Error in sync, please reload the page",
                                });
                                setTimeout(function () {
                                    $("#Alertmsgbtn").click();
                                }, 50);
                            }
                        );
                    }
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ShowMTBSampleStatusModal = (id) => {
        this.setState({
            SampleId: id,
            MTBId: 0,
            RRId: 0,
        });
        $("#Status_Description").val("");
        $("#UpdateStatusModal_btn").click();
    };
    SaveMTBResultStatus = (e) => {
        e.preventDefault();
        if (this.state.MTBId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: "MTB result is required" });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }
        if (this.state.RRId === 0) {
            this.props.ShowAlert({ Type: 0, Msg: "RR result is required" });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }
        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            id: this.state.SampleId,
            mtbResult: this.state.MTBId,
            mtbDetailResult: this.state.MTBRatingId,
            rrResult: this.state.RRId,
            resultDescription: $("#Status_Description").val(),
        };

        if (this.props.UserAuthentication.UserInfo?.roleId == 3) {
            Parameters.mtbperformedby =
                this.props.UserAuthentication.UserInfo?.xpertSiteId;
        }

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Save_SampleResult,
            Parameters,
            (resp) => {
                if (resp.status) {
                    SyncConfig(
                        () => {
                            this.setState({
                                SampleId: 0,
                                MTBId: 0,
                                RRId: 0,
                            });
                            $("#Status_Description").val("");
                            $("#UpdateStatusModal_Closebtn").click();
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
                            setTimeout(() => {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        },
                        () => {
                            this.setState({
                                SampleId: 0,
                                MTBId: 0,
                                RRId: 0,
                                MTBRatingId: null,
                            });
                            $("#Status_Description").val("");
                            $("#UpdateStatusModal_Closebtn").click();
                            this.PopulateTable();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: "Error in sync, please reload the page",
                            });
                            setTimeout(function () {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        }
                    );
                } else {
                    if (resp.message && this.props.UserAuthentication.roleId === 3) {
                        Common.Ajax(
                            this.props.UserAuthentication.AuthToken,
                            "GET",
                            false,
                            Common.BaseUrlAPI + "/api/PatientSamples/UpdatePatientSample",
                            { id: this.state.SampleId },
                            (res) => {
                                if (res.status) {
                                    Common.Ajax(
                                        this.props.UserAuthentication.AuthToken,
                                        "Get",
                                        false,
                                        Common.APILinks.Save_SampleResult,
                                        Parameters,
                                        (resp) => {
                                            SyncConfig(
                                                () => {
                                                    this.setState({
                                                        SampleId: 0,
                                                        MTBId: 0,
                                                        RRId: 0,
                                                    });
                                                    $("#Status_Description").val("");
                                                    $("#UpdateStatusModal_Closebtn").click();
                                                    this.PopulateTable();
                                                    this.props.ShowLoader({ Isloading: false });
                                                    this.props.ShowAlert({
                                                        Type: 1,
                                                        Msg: "Saved successfully",
                                                    });
                                                    setTimeout(() => {
                                                        $("#Alertmsgbtn").click();
                                                    }, 50);
                                                },
                                                () => {
                                                    this.setState({
                                                        SampleId: 0,
                                                        MTBId: 0,
                                                        RRId: 0,
                                                    });
                                                    $("#Status_Description").val("");
                                                    $("#UpdateStatusModal_Closebtn").click();
                                                    this.PopulateTable();
                                                    this.props.ShowLoader({ Isloading: false });
                                                    this.props.ShowAlert({
                                                        Type: 0,
                                                        Msg: "Error in sync, please reload the page",
                                                    });
                                                    setTimeout(function () {
                                                        $("#Alertmsgbtn").click();
                                                    }, 50);
                                                }
                                            );
                                        }
                                    );
                                }
                            },
                            (error) => {
                                console.log("error", error);
                            }
                        );
                    }
                    // this.props.ShowLoader({Isloading: false})
                    // this.props.ShowAlert({Type: 0, Msg: resp.message})
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ShowMicroscopyStatusModal = (id) => {
        this.setState({
            SampleId: id,
        });
        $("#UpdateMicroscopyModal_btn").click();
    };
    UpdateMicroscopyStatus = (event) => {
        event.preventDefault();

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "POST",
            false,
            Common.BaseUrlAPI +
            `/api/PatientSamples/UpdateMicroscopyStatus?sample_id=${this.state.SampleId
            }&MicroscopyStatus=${$("#MicroscopyStatus").val()}`,
            {},
            (resp) => {
                if (resp.status) {
                    $("#UpdateMicroscopyModal_btn").click();
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
                    this.PopulateTable();
                }
            },
            (error) => {
                console.log("Error", error);
            }
        );
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientSample_List);
